import { api } from "@/lib/api"
import { AnalyticsChart } from "./analytics-chart"

export function DocsChart() {
	const docsChartQuery = api.analytics.docsChart.useQuery({})

	return (
		<AnalyticsChart
			title="Docs"
			data={docsChartQuery.data}
			isLoading={docsChartQuery.isLoading}
		/>
	)
}
